import { useEffect, useState } from 'react';
import { api } from '../api/client.js';
import { normalizeQuestionsBank, STATIC_QUESTIONS_BANK } from '../utils/coachQuestionsBank.js';

const THEME = {
    escuchar: '#0f766e',
    error: '#dc2626',
    adaptarse: '#ca8a04',
    proposito: '#16a34a',
};

/** Preguntas frecuentes inline (columna 1) — evita modal recortado por overflow. */
export default function SupervisorFaqPanel({ questionsBank: initialBank = null }) {
    const [open, setOpen] = useState(false);
    const [bank, setBank] = useState(
        () => normalizeQuestionsBank(initialBank) ?? STATIC_QUESTIONS_BANK
    );
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const next = normalizeQuestionsBank(initialBank);
        if (next) setBank(next);
    }, [initialBank]);

    async function handleToggle() {
        const willOpen = !open;
        setOpen(willOpen);
        if (!willOpen) return;

        if (normalizeQuestionsBank(bank)) return;

        setLoading(true);
        try {
            const res = await api.getPowerfulQuestions();
            setBank(normalizeQuestionsBank(res) ?? STATIC_QUESTIONS_BANK);
        } catch (err) {
            console.error('Preguntas frecuentes:', err);
            setBank(STATIC_QUESTIONS_BANK);
        } finally {
            setLoading(false);
        }
    }

    const sections = Object.entries(bank || STATIC_QUESTIONS_BANK);

    return (
        <section className="sup-faq-block" aria-label="Preguntas frecuentes">
            <button
                type="button"
                className="sup-profile-toggle"
                onClick={handleToggle}
                aria-expanded={open}
            >
                {open ? '▾' : '▸'} Preguntas frecuentes
            </button>
            {open && (
                <div className="sup-faq-body">
                    <p className="sup-faq-lead">
                        Elige una para conversar con tu equipo. Luego revisa Manada o Personas en las columnas de la
                        derecha.
                    </p>
                    {loading ? (
                        <p className="sup-team-hint">Cargando…</p>
                    ) : (
                        <div className="sup-faq-sections">
                            {sections.map(([key, section]) => (
                                <div
                                    key={key}
                                    className="sup-faq-section"
                                    style={{ borderLeftColor: THEME[key] || '#64748b' }}
                                >
                                    <p className="sup-faq-section-title">{section.purpose}</p>
                                    <ul>
                                        {(section.questions || []).map((q, i) => (
                                            <li key={i}>{q}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </section>
    );
}
